// src/pages/CategoriasProductos.jsx
import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";

import AddCategoriaProducto from "../components/AddCategoriaProducto";
import TableCategoriaProducto from "../components/TableCategoriaProducto";
// import Footer from "../components/Footer";

import "../css/admin.css";

const CategoriasProductos = () => {
  const [usuario, setUsuario] = useState({});
  const [show, setShow] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      try {
        const token_decode = jwt_decode(token);
        setUsuario(token_decode.usuario);
      } catch (e) {
        console.error("❌ Error al decodificar token:", e);
        setUsuario({});
      }
    }
  }, [token]);

  return (
    <>
      <div className="cabecera">
        {token ? (
          <div className="container mt-5">
            {usuario?.role === "ADMIN_ROLE" ? (
              <>
                <h3 className="mt-3 mb-2">GESTIÓN CATEGORÍAS DE PRODUCTOS</h3>
                <hr />

                <div className="mt-3 mb-3">
                  <AddCategoriaProducto setShow={setShow} show={show} />
                </div>

                <div className="mt-3 mb-3">
                  {!show && <TableCategoriaProducto />}
                </div>
              </>
            ) : (
              <div className="alert alert-info" role="alert">
                Lo sentimos, pero no tiene permisos para acceder a este contenido.
              </div>
            )}
          </div>
        ) : (
          <div className="container mt-5">
            <div className="alert alert-danger" role="alert">
              No se encuentra logueado en la plataforma.
            </div>
          </div>
        )}
      </div>

      {/* <Footer /> */}
    </>
  );
};

export default CategoriasProductos;